/**
 * Configuração de ambiente do Control_Panel.
 *
 * A base URL da Ingestion_API é injetada em build via variável Vite
 * (`VITE_API_BASE_URL`). O usuário pode sobrescrevê-la nas configurações
 * (guardada no localStorage) para apontar para um ambiente diferente sem
 * rebuild — útil em dev/homologação. Nunca há segredo embutido no bundle
 * (a API key vem do usuário; ver `lib/settings.ts` e AD-7).
 */

function readEnv(key: string): string | undefined {
  // `import.meta.env` é populada pelo Vite. Acesso defensivo para os testes.
  const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;
  const value = env?.[key];
  return typeof value === "string" && value.trim() !== "" ? value.trim() : undefined;
}

/** Base URL default da API, sem barra final. */
export const DEFAULT_API_BASE_URL =
  readEnv("VITE_API_BASE_URL") ?? "https://makepub.wecando.click";

/** Rótulo de ambiente exibido discretamente (ex.: "dev"). */
export const ENV_LABEL = readEnv("VITE_ENV_LABEL") ?? "";

/** Normaliza uma base URL removendo barras finais. */
export function normalizeBaseUrl(url: string): string {
  return url.trim().replace(/\/+$/, "");
}
